<template>
  <div class="layout">
    <div class="cabinet-page_bg"></div>

    <div class="content">

      <div class="content-right">
        <div class="content-right-inner">
          <div class="logo">
            <Logo/>
          </div>
          <div class="title" v-html="$ml.with('VueJS').get('thanksMessage')"></div>
          <div class="text">
            <p v-html="$ml.with('VueJS').get('checkYourEmail')"></p>
            <p>
              <router-link class="action-link" :to="{name:'Index', query: {login:'true'}}"
                           v-html="$ml.with('VueJS').get('goToIndex')"></router-link>
            </p>
          </div>

        </div>
      </div>

    </div>

    <div class="notice-page-bg"></div>

  </div>
</template>

<script>

import Logo from "../components/icons/Logo";

export default {
  name: "RegistrationThanks",
  components: {Logo},
  beforeCreate() {
    $('body').attr('class', 'notice-page index-layout');
  }
}
</script>

<style scoped>

</style>